function getTitle(vm) {
  const { title } = vm.$options
  if (title) {
    let prefix =
      vm.config.VUE_APP_STAGE !== 'PROD'
        ? '[' + vm.config.VUE_APP_STAGE + '] '
        : ''
    return typeof title === 'function'
      ? prefix + title.call(vm)
      : prefix + title
  }
}
export default {
  created() {
    const title = getTitle(this)
    if (title) {
      document.title = title
    }
  }
}
